// Registers the kiosk-scoped service worker. Idempotent — repeated calls
// (e.g. on React strict-mode double-render) are safe. Scope is /kiosk/ so
// the rest of the Budget app isn't accidentally PWA-ified.
//
// In dev, Vite's HMR doesn't play nicely with a service worker, so we
// only register in production builds. Use the build (vite build && vite
// preview) when testing the offline path locally.

export function registerKioskServiceWorker(): void {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  if (!import.meta.env.PROD) return;

  // Don't await — registration races with the rest of the SPA bootstrap.
  void navigator.serviceWorker
    .register('/kiosk-sw.js', { scope: '/kiosk/' })
    .catch(() => {
      // The SW is a nice-to-have; never let a registration failure block
      // the dashboard from rendering.
    });
}
